var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47.35px",
    height: "71.58px",
    viewBox: "0 0 47.35 71.58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-781.440000, -1944.660000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    transform: "translate(-0.060000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_113",
    fill: "#BEB0FF",
    points: "804 1969.66 828.85 1969.66 828.85 1978.06 804 1978.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_114",
    fill: "#000000",
    points: "820.44 1965.64 820.44 1953.06 789.91 1953.06 789.91 2007.37 820.44 2007.76 820.44 1982.08 828.85 1982.08 828.85 2016.24 781.5 2015.64 781.5 1944.66 828.85 1944.66 828.85 1965.64"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/Icon8.c7208da48a1a4ef9a6d608e9a82af4a9.svg";
export { ForwardRef as ReactComponent };